<!-- ═══ Backdrop ═══ -->
<div
  *ngIf="!pageMode"
  class="sidebar-backdrop"
  [class.sidebar-backdrop--visible]="isOpen"
  (click)="onBackdropClick()"
></div>

<!-- ═══ Sidebar Panel ═══ -->
<aside class="sidebar" [class.sidebar--open]="isOpen" [class.sidebar--page]="pageMode">

  <!-- ─────────────────────────────────── -->
  <!-- LIST VIEW                           -->
  <!-- ─────────────────────────────────── -->
  <div class="sidebar-view" *ngIf="view === 'list'">

    <!-- Header -->
    <div class="sidebar-header">
      <div class="sidebar-header__row">
        <h2 class="sidebar-header__title">
          <mat-icon class="sidebar-header__icon">contacts</mat-icon>
          Contacts
        </h2>
        <button *ngIf="!pageMode" class="icon-btn" (click)="close()" aria-label="Close sidebar">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- Search -->
      <div class="search-box">
        <mat-icon class="search-box__icon">search</mat-icon>
        <input
          #searchInput
          class="search-box__input"
          type="text"
          placeholder="Search by name, email, company..."
          [value]="search"
          (input)="onSearchInput($any($event.target).value)"
        />
        <button
          *ngIf="search"
          class="search-box__clear"
          (click)="clearSearch()"
          aria-label="Clear search"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- Filter Tabs -->
      <div class="filter-tabs">
        <button
          *ngFor="let f of filters"
          class="filter-tab"
          [class.filter-tab--active]="activeFilter === f.key"
          (click)="setFilter(f.key)"
        >
          {{ f.label }}
          <span class="filter-tab__count" *ngIf="f.count != null">{{ f.count }}</span>
        </button>
      </div>
    </div>

    <!-- Add button (top) -->
    <div class="sidebar-topbar">
      <button class="add-btn" (click)="openCreateDialog()">
        <mat-icon>add</mat-icon>
        New Contact
      </button>
    </div>

    <!-- Contact List -->
    <div class="contact-list" (scroll)="onListScroll($event)">
      <!-- Loading skeleton -->
      <div *ngIf="loading" class="skeleton-list">
        <div class="skeleton-row" *ngFor="let i of [1,2,3,4,5,6,7,8]">
          <div class="skeleton-avatar"></div>
          <div class="skeleton-lines">
            <div class="skeleton-line skeleton-line--name"></div>
            <div class="skeleton-line skeleton-line--sub"></div>
          </div>
        </div>
      </div>

      <!-- Aggregated form contacts (Customers) — read-only, client-side filtered -->
      <ng-container *ngIf="!loading && visibleFormContacts.length > 0">
        <div class="contact-section-header">
          Customers
          <span class="contact-section-header__count">{{ visibleFormContacts.length }}</span>
        </div>
        <div
          *ngFor="let contact of visibleFormContacts; trackBy: trackByContact"
          class="contact-item contact-item--form"
          [class.contact-item--selected]="selectedContact?.id === contact.id"
          (click)="selectContact(contact)"
        >
          <div
            class="contact-item__avatar"
            [style.background]="'hsl(' + getAvatarHue(contact) + ', 55%, 92%)'"
            [style.color]="'hsl(' + getAvatarHue(contact) + ', 50%, 35%)'"
          >
            {{ getInitials(contact) }}
          </div>

          <div class="contact-item__info">
            <span class="contact-item__name">
              {{ contact.firstName }} {{ contact.lastName }}
            </span>
            <span class="contact-item__sub">{{ getSubtitle(contact) }}</span>
          </div>

          <div class="contact-item__actions" (click)="$event.stopPropagation()">
            <button
              *ngIf="contact.mobilePhone || contact.workPhone"
              class="quick-btn"
              (click)="call3CX(contact.mobilePhone || contact.workPhone)"
              title="Call via 3CX"
            >
              <mat-icon>phone</mat-icon>
            </button>
            <button
              *ngIf="contact.email"
              class="quick-btn"
              (click)="emailContact(contact)"
              title="Email"
            >
              <mat-icon>email</mat-icon>
            </button>
          </div>

          <span class="contact-item__form-badge" [title]="contact.formContactType">
            {{ contact.formContactType }}
          </span>
        </div>

        <div class="contact-section-header" *ngIf="contacts.length > 0">
          Contacts
          <span class="contact-section-header__count">{{ total }}</span>
        </div>
      </ng-container>

      <!-- Contact items -->
      <div
        *ngFor="let contact of contacts; trackBy: trackByContact"
        class="contact-item"
        [class.contact-item--selected]="selectedContact?.id === contact.id"
        (click)="selectContact(contact)"
      >
        <div
          class="contact-item__avatar"
          [style.background]="'hsl(' + getAvatarHue(contact) + ', 55%, 92%)'"
          [style.color]="'hsl(' + getAvatarHue(contact) + ', 50%, 35%)'"
        >
          {{ getInitials(contact) }}
        </div>

        <div class="contact-item__info">
          <span class="contact-item__name">
            {{ contact.firstName }} {{ contact.lastName }}
          </span>
          <span class="contact-item__sub">{{ getSubtitle(contact) }}</span>
        </div>

        <div class="contact-item__actions" (click)="$event.stopPropagation()">
          <button
            *ngIf="contact.mobilePhone || contact.workPhone"
            class="quick-btn"
            [matMenuTriggerFor]="listCallMenu"
            title="Call"
          >
            <mat-icon>phone</mat-icon>
          </button>
          <mat-menu #listCallMenu="matMenu" class="call-channel-menu">
            <button mat-menu-item (click)="call3CX(contact.mobilePhone || contact.workPhone)">
              <mat-icon>phone_in_talk</mat-icon> 3CX
            </button>
            <button mat-menu-item (click)="callWhatsApp(contact.mobilePhone || contact.workPhone)">
              <mat-icon>chat</mat-icon> WhatsApp
            </button>
            <button mat-menu-item (click)="callTelegram(contact.mobilePhone || contact.workPhone)">
              <mat-icon>send</mat-icon> Telegram
            </button>
          </mat-menu>
          <button
            *ngIf="contact.email"
            class="quick-btn"
            (click)="emailContact(contact)"
            title="Email"
          >
            <mat-icon>email</mat-icon>
          </button>
        </div>

        <!-- Type indicator dot -->
        <span
          class="contact-item__type-dot"
          [style.background]="getTypeColor(contact.contactType)"
          [title]="contact.contactType"
        ></span>
      </div>

      <!-- Loading more -->
      <div class="loading-more" *ngIf="loadingMore">
        <div class="spinner"></div>
      </div>

      <!-- Empty state -->
      <div class="empty-state" *ngIf="!loading && contacts.length === 0">
        <mat-icon class="empty-state__icon">person_search</mat-icon>
        <p class="empty-state__title">No contacts found</p>
        <p class="empty-state__sub">Try a different search or filter</p>
      </div>
    </div>

  </div>

  <!-- ─────────────────────────────────── -->
  <!-- DETAIL VIEW                         -->
  <!-- ─────────────────────────────────── -->
  <div class="sidebar-view" *ngIf="view === 'detail' && selectedContact">

    <!-- Detail Header -->
    <div class="detail-header">
      <button class="back-btn" (click)="backToList()" aria-label="Back to contacts">
        <mat-icon>arrow_back</mat-icon>
        <span>Contacts</span>
      </button>
      <span class="detail-header__title"></span>
      <button *ngIf="!pageMode" class="icon-btn" (click)="close()" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Detail Body -->
    <div class="detail-body">
      <!-- Profile Card -->
      <div class="detail-profile">
        <div
          class="detail-avatar"
          [style.background]="'hsl(' + getAvatarHue(selectedContact) + ', 55%, 90%)'"
          [style.color]="'hsl(' + getAvatarHue(selectedContact) + ', 50%, 32%)'"
        >
          {{ getInitials(selectedContact) }}
        </div>
        <h3 class="detail-name">
          {{ selectedContact.firstName }} {{ selectedContact.lastName }}
        </h3>
        <p class="detail-title" *ngIf="selectedContact.jobTitle || selectedContact.company">
          {{ selectedContact.jobTitle }}
          <span *ngIf="selectedContact.jobTitle && selectedContact.company"> at </span>
          {{ selectedContact.company }}
        </p>

        <!-- Type badge -->
        <span
          class="detail-badge"
          [style.background]="getTypeBadgeBg(selectedContact.contactType)"
          [style.border-color]="getTypeBadgeBorder(selectedContact.contactType)"
          [style.color]="getTypeBadgeText(selectedContact.contactType)"
        >
          {{ selectedContact.contactType }}
        </span>
      </div>

      <!-- Quick Action Buttons -->
      <div class="detail-quick-actions">
        <button
          class="detail-action-btn"
          *ngIf="selectedContact.mobilePhone || selectedContact.workPhone"
          (click)="call3CX(selectedContact.mobilePhone || selectedContact.workPhone)"
        >
          <mat-icon>phone</mat-icon>
          <span>Call</span>
        </button>
        <button
          class="detail-action-btn"
          *ngIf="selectedContact.email"
          (click)="emailContact(selectedContact)"
        >
          <mat-icon>email</mat-icon>
          <span>Email</span>
        </button>
        <button class="detail-action-btn" (click)="pickContact(selectedContact)">
          <mat-icon>person_add</mat-icon>
          <span>Select</span>
        </button>
        <button class="detail-action-btn" [matMenuTriggerFor]="shareMenu">
          <mat-icon>share</mat-icon>
          <span>Share</span>
        </button>
        <mat-menu #shareMenu="matMenu">
          <button mat-menu-item (click)="shareContact(selectedContact, 'clipboard')">
            <mat-icon>content_copy</mat-icon> Copy to clipboard
          </button>
          <button mat-menu-item (click)="shareContact(selectedContact, 'email')">
            <mat-icon>email</mat-icon> Email
          </button>
          <button mat-menu-item (click)="shareContact(selectedContact, 'whatsapp')">
            <mat-icon>chat</mat-icon> WhatsApp
          </button>
          <button mat-menu-item (click)="shareContact(selectedContact, 'telegram')">
            <mat-icon>send</mat-icon> Telegram
          </button>
        </mat-menu>
      </div>

      <!-- Info Fields -->
      <div class="detail-fields">
        <div class="detail-field" *ngIf="selectedContact.email">
          <mat-icon class="detail-field__icon">email</mat-icon>
          <div class="detail-field__content">
            <span class="detail-field__label">Email</span>
            <a class="detail-field__value detail-field__value--link" [href]="'mailto:' + selectedContact.email">
              {{ selectedContact.email }}
            </a>
          </div>
        </div>

        <div class="detail-field" *ngIf="selectedContact.mobilePhone">
          <mat-icon class="detail-field__icon">phone_iphone</mat-icon>
          <div class="detail-field__content">
            <span class="detail-field__label">Mobile</span>
            <div class="detail-field__phone-row">
              <span class="detail-field__value">{{ selectedContact.mobilePhone }}</span>
              <div class="phone-actions">
                <a class="phone-action-btn phone-action-btn--3cx"
                   title="Call via 3CX"
                   [href]="'tel:' + cleanPhone(selectedContact.mobilePhone)">
                  <mat-icon>phone_in_talk</mat-icon>
                </a>
                <a class="phone-action-btn phone-action-btn--whatsapp"
                   title="WhatsApp"
                   [href]="'https://wa.me/' + cleanPhone(selectedContact.mobilePhone).replace('+', '')"
                   target="_blank">
                  <mat-icon>chat</mat-icon>
                </a>
                <a class="phone-action-btn phone-action-btn--telegram"
                   title="Telegram"
                   [href]="'https://t.me/' + cleanPhone(selectedContact.mobilePhone)"
                   target="_blank">
                  <mat-icon>send</mat-icon>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="detail-field" *ngIf="selectedContact.workPhone">
          <mat-icon class="detail-field__icon">phone</mat-icon>
          <div class="detail-field__content">
            <span class="detail-field__label">Work phone</span>
            <div class="detail-field__phone-row">
              <span class="detail-field__value">{{ selectedContact.workPhone }}</span>
              <div class="phone-actions">
                <a class="phone-action-btn phone-action-btn--3cx"
                   title="Call via 3CX"
                   [href]="'tel:' + cleanPhone(selectedContact.workPhone)">
                  <mat-icon>phone_in_talk</mat-icon>
                </a>
                <a class="phone-action-btn phone-action-btn--whatsapp"
                   title="WhatsApp"
                   [href]="'https://wa.me/' + cleanPhone(selectedContact.workPhone).replace('+', '')"
                   target="_blank">
                  <mat-icon>chat</mat-icon>
                </a>
                <a class="phone-action-btn phone-action-btn--telegram"
                   title="Telegram"
                   [href]="'https://t.me/' + cleanPhone(selectedContact.workPhone)"
                   target="_blank">
                  <mat-icon>send</mat-icon>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="detail-field" *ngIf="selectedContact.department">
          <mat-icon class="detail-field__icon">groups</mat-icon>
          <div class="detail-field__content">
            <span class="detail-field__label">Department</span>
            <span class="detail-field__value">{{ selectedContact.department }}</span>
          </div>
        </div>

        <div class="detail-field" *ngIf="selectedContact.city || selectedContact.country || selectedContact.address">
          <mat-icon class="detail-field__icon">location_on</mat-icon>
          <div class="detail-field__content">
            <span class="detail-field__label">Location</span>
            <span class="detail-field__value">
              {{ [selectedContact.address, selectedContact.city, selectedContact.country] | bcJoinTruthy:', ' }}
            </span>
          </div>
        </div>

        <div class="detail-field" *ngIf="selectedContact.tic">
          <mat-icon class="detail-field__icon">badge</mat-icon>
          <div class="detail-field__content">
            <span class="detail-field__label">TIC</span>
            <span class="detail-field__value">{{ selectedContact.tic }}</span>
          </div>
        </div>

        <div class="detail-field" *ngIf="selectedContact.vatNumber">
          <mat-icon class="detail-field__icon">receipt_long</mat-icon>
          <div class="detail-field__content">
            <span class="detail-field__label">VAT number</span>
            <span class="detail-field__value">{{ selectedContact.vatNumber }}</span>
          </div>
        </div>

        <div class="detail-field" *ngIf="selectedContact.preferredContactMethods?.length">
          <mat-icon class="detail-field__icon">forum</mat-icon>
          <div class="detail-field__content">
            <span class="detail-field__label">Preferred contact</span>
            <div class="channel-chip-row">
              <span class="channel-chip channel-chip--readonly"
                    *ngFor="let m of selectedContact.preferredContactMethods">
                <mat-icon>{{ contactMethodIcon(m) }}</mat-icon>
                <span>{{ m }}</span>
              </span>
            </div>
          </div>
        </div>

        <div class="detail-field detail-field--notes" *ngIf="selectedContact.notes">
          <mat-icon class="detail-field__icon">description</mat-icon>
          <div class="detail-field__content">
            <span class="detail-field__label">Notes</span>
            <span class="detail-field__value detail-field__value--notes">{{ selectedContact.notes }}</span>
          </div>
        </div>
      </div>

      <!-- ─── Timestamped Notes Thread ─── -->
      <section class="notes-thread" *ngIf="!selectedContact.isFormContact">
        <div class="notes-thread__header">
          <mat-icon class="notes-thread__icon">forum</mat-icon>
          <span class="notes-thread__title">Notes</span>
          <span class="notes-thread__count" *ngIf="notes.length">{{ notes.length }}</span>
        </div>

        <!-- Composer -->
        <div class="notes-composer">
          <textarea
            class="notes-composer__input"
            [(ngModel)]="newNoteBody"
            placeholder="Write a note about this contact…"
            rows="3"
            [disabled]="addingNote"
          ></textarea>
          <div class="notes-composer__actions">
            <button
              class="notes-composer__send"
              type="button"
              (click)="addNote()"
              [disabled]="!newNoteBody.trim() || addingNote"
            >
              <mat-icon>{{ addingNote ? 'hourglass_top' : 'send' }}</mat-icon>
              <span>{{ addingNote ? 'Adding…' : 'Add note' }}</span>
            </button>
          </div>
        </div>

        <!-- Timeline -->
        <div class="notes-list" *ngIf="notes.length; else notesEmpty">
          <article class="note-entry" *ngFor="let n of notes">
            <div class="note-entry__avatar">
              {{ (n.authorName || '?').charAt(0).toUpperCase() }}
            </div>
            <div class="note-entry__body">
              <header class="note-entry__head">
                <span class="note-entry__author">{{ n.authorName || 'Unknown' }}</span>
                <span class="note-entry__time" [title]="n.createdAt">{{ formatNoteTime(n.createdAt) }}</span>
              </header>
              <p class="note-entry__text">{{ n.body }}</p>
              <button
                class="note-entry__delete"
                type="button"
                (click)="deleteNote(n)"
                aria-label="Delete note"
                title="Delete note"
              >
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </article>
        </div>

        <ng-template #notesEmpty>
          <p class="notes-list__empty" *ngIf="!notesLoading">No notes yet — be the first to add one.</p>
          <p class="notes-list__empty" *ngIf="notesLoading">Loading notes…</p>
        </ng-template>
      </section>
    </div>

    <!-- Detail Footer -->
    <div class="detail-footer">
      <ng-container *ngIf="!selectedContact.isFormContact; else readOnlyFooter">
        <button class="footer-btn footer-btn--danger" (click)="openDeleteDialog(selectedContact)">
          <mat-icon>delete</mat-icon>
        </button>
        <button class="footer-btn footer-btn--primary" (click)="openEditDialog(selectedContact)">
          <mat-icon>edit</mat-icon>
          Edit
        </button>
      </ng-container>
      <ng-template #readOnlyFooter>
        <span class="detail-footer__readonly">
          <mat-icon>lock</mat-icon>
          Read-only · Managed via submitted forms
        </span>
      </ng-template>
    </div>
  </div>

</aside>
